import Button1 from "../../form/Button1";
import Modal1 from "../../DIsplay/Modal/Modal1";

export function SupplierResponseJson({ data }) {
  if (data == null) {
    return (
      <span className="block text-sm text-gray-500">
        No supplier response available.
      </span>
    );
  }

  const entries =
    typeof data === "object" && !Array.isArray(data)
      ? Object.entries(data)
      : null;

  return (
    <div className="flex flex-col gap-3">
      {entries?.length ? (
        <div className="border rounded-md divide-y overflow-hidden">
          {entries.map(([key, value]) => (
            <div
              key={key}
              className="flex gap-3 px-3 py-2 text-sm items-start"
            >
              <span className="font-semibold text-gray-800 min-w-[120px] shrink-0">
                {key}
              </span>
              <span className="text-gray-700 break-all font-mono text-xs">
                {typeof value === "object" && value !== null
                  ? JSON.stringify(value)
                  : String(value)}
              </span>
            </div>
          ))}
        </div>
      ) : null}
      <pre className="whitespace-pre-wrap break-words text-xs text-gray-800 leading-relaxed font-mono bg-gray-50 border rounded-md p-3 max-h-[50vh] overflow-auto m-0">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
}

export default function SupplierResponseModal({
  open,
  setOpen,
  data,
  orderId,
}) {
  return (
    <Modal1 open={open} setOpen={setOpen}>
      <div className="card p-4 flex flex-col gap-4 min-w-[320px] sm:min-w-[480px] max-w-[90vw]">
        <h5>Supplier Response</h5>
        {orderId ? (
          <span className="block text-sm text-gray-500">Order {orderId}</span>
        ) : null}
        <SupplierResponseJson data={data} />
        <div className="flex justify-end">
          <Button1
            variant="outlined"
            className="btn-outlined !w-auto"
            onClick={() => setOpen && setOpen(false)}
          >
            Close
          </Button1>
        </div>
      </div>
    </Modal1>
  );
}
